import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const PptIcon = ({ color = '#e45d5d', text = 'PPT' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default PptIcon;
